import SettingsModule, {SettingsMenuTopCategory} from "../../../../core/modules/settings-module";
import {SettingsSection} from "../../@const";

export default class ProjectTemplatesSettingsModule extends SettingsModule {

    constructor() {
        super({
            name                     : "Project Templates",
            description              : "You can use project types both as a preset of project-specific settings i.e. workflow, views, type of tasks, or as a project template that comes with pre-created tasks, milestones, etc.",
            svgIcon                  : "isvg-project-templates",
            settingsUrl              : "settings/templates",
            settingsMenuTopCategory  : SettingsMenuTopCategory.ORGANIZATION,
            settingsSection          : SettingsSection.TASKS_PROJECTS

        });
    }

}
